/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import PrivacyPolicy from '../components/Policies/PrivacyPolicy'

export const PrivacyPageTemplate = ({
  title,
  heading,
  subheading,
  description,
  services,
  meta_title,
  meta_description
}) => (
  <div>
    <Helmet>
      <title>{meta_title}</title>
      <meta name='description' content={meta_description} />
      <link rel="icon" 
        type="image/png" 
        href="/img/pesilogo_32x32.png"/>
    </Helmet>
   
    <section className='hero is-primary is-bold'>
      <div className='container'>
        <div className='hero-body'>
          <div className='columns'>
            <div className='column is-12 '>
              <h1 className='title' id='content'>{title}</h1>
              <h2 className=' subtitle'>{subheading}</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div style={{
      margin: '0 auto',
      maxWidth: 960,
      padding: '0px 1.0875rem 1.45rem',
      paddingTop: 0,
    }}>
      <section className='section section--gradient'>
        <div className='container'>
          <div >
            <div className='columns'>
              <div className='column'>
                <div className='content '>              
                  <h3 className='has-text-weight-semibold  has-text-centered'>
                    {heading}
                  </h3>
                  <p className='has-text-justified'>{description}</p>               
                </div>
              </div>
            </div> 
          </div>
        </div>
      </section> 

      <section className='section'>
        <div className='container'>
        <PrivacyPolicy />
        </div>
      </section>
    </div>
  </div>
)

PrivacyPageTemplate.propTypes = {
  title: PropTypes.string,
  meta_title: PropTypes.string,
  meta_description: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  description: PropTypes.string,
  edges: PropTypes.array
}

const PrivacyPage = ({data}) => {
  const {frontmatter} = data.markdownRemark

  return (
    <PrivacyPageTemplate
      title={frontmatter.title}
      meta_title={frontmatter.meta_title}
      meta_description={frontmatter.meta_description}
      heading={frontmatter.heading}
      subheading={frontmatter.subheading}
    />
  )
}

PrivacyPage.propTypes = {
  data: PropTypes.shape({
    allSlidesJson: PropTypes.shape({
      edges: PropTypes.Array
    }),
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.object,
    }),
  }),
}

export default PrivacyPage

export const pageQuery = graphql`
  query PrivacyPage($id: String!) {
    allSlideDecksJson {
      edges {
        node {
          ...CarouselSlides
        }
      }
    }
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        meta_title
        meta_description
        description
      }
    }
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 100)
          id
          fields {
            slug
          }
          frontmatter {
            title
            cover
            templateKey
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/privacy-page.js